import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"
import { PencilSimple, TrashSimple } from "@phosphor-icons/react"
import { fetchQuery } from "relay-runtime"
import { Button } from "@/components/ui/button"
import { toast } from "@/hooks/useToast"
import { useDeletePersonalTreatmentPlanTemplateMutationHook } from "@/modules/admin/treatment/services/useDeletePersonalTreatmentPlanTemplateMutation"
import { TreatmentPlanItem, treatmentQuery } from "@/modules/admin/treatment/services/useTreatmentQuery"
import { RelayEnvironment } from "@/relay-environment"
import { useConfirmStore } from "@/stores/useConfirmStore"

interface TreatmentTableActionProps {
  row: TreatmentPlanItem
}

const TreatmentTableActions = (props: TreatmentTableActionProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const confirm = useConfirmStore((state) => state.confirm)
  const cancel = useConfirmStore((state) => state.cancel)
  const [deletePersonalTreatmentPlanTemplate] = useDeletePersonalTreatmentPlanTemplateMutationHook()

  const onEditClick = (id: string) => {
    navigate(`edit/${id}`)
  }

  const handleConfirmDelete = (id: string) => {
    deletePersonalTreatmentPlanTemplate({
      variables: {
        input: {
          id: id,
        },
      },
      onCompleted(response) {
        if (response.deletePersonalTreatmentPlanTemplate.treatmentPlanTemplate) {
          toast({
            description: t("admin.treatment.message.deleteSuccess"),
          })
          fetchQuery(RelayEnvironment, treatmentQuery, {}).subscribe({})
          cancel()
        }
      },
    })
  }

  const onDelete = (id: string) => {
    confirm({
      title: t("admin.treatment.popup.delete.title"),
      content: "",
      cancelText: t("common.button.cancel"),
      confirmText: t("common.button.delete"),
      onConfirm: () => {
        handleConfirmDelete(id)
      },
    })
  }

  return (
    <div className="flex">
      <div className="group">
        <div className="cursor-pointer">
          <Button
            data-testid="treatment-template-edit-button"
            onClick={(e) => {
              e.stopPropagation()
              onEditClick(props.row.id)
            }}
            variant="circle"
            className="h-10 w-10">
            <PencilSimple className="text-on-surface-subdued" />
          </Button>
        </div>
      </div>

      <div className="group">
        <div className="cursor-pointer">
          <Button
            data-testid="treatment-template-delete-button"
            onClick={(e) => {
              e.stopPropagation()
              onDelete(props.row.id)
            }}
            variant="circle"
            className="h-10 w-10">
            <TrashSimple className="text-on-surface-subdued" />
          </Button>
        </div>
      </div>
    </div>
  )
}

export { TreatmentTableActions }
